import { CommunicationProviderState } from './types';

const defaultCommunicationProviderState = (): CommunicationProviderState => ({
  communicationAlertsList: null,
  selectedCommunicationAlert: null,
  selectedCategory: null,
  selectedTask: null,
  refetchCommunicationAlertListData: () => {},
  loadingState: {
    isLoadingCommunicationAlertsListData: false,
  },
  errorState: {
    communicationAlertsListDataError: undefined,
  },
});

export { defaultCommunicationProviderState };
